import { render, staticRenderFns } from "./PropertyAlerts.vue?vue&type=template&id=7eb0d4e1"
import script from "./PropertyAlerts.vue?vue&type=script&lang=js"
export * from "./PropertyAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports